var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.06,
    height: 20.399,
    viewBox: "0 0 22.06 20.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5343",
    "data-name": "Rectangle 5343",
    width: 22.06,
    height: 20.399,
    fill: "#0d3b66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14430",
    "data-name": "Group 14430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14426",
    "data-name": "Group 14426",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46418",
    "data-name": "Path 46418",
    d: "M21.545,4,19.138,5.286a10.2,10.2,0,1,0-1.864,12.261.35.35,0,0,0,0-.5L15.737,15.56a.352.352,0,0,0-.488,0A7.367,7.367,0,0,1,2.857,9.6,7.364,7.364,0,0,1,16.639,6.626L14.464,7.791a.35.35,0,0,0,.033.632l5.826,2.368a.349.349,0,0,0,.474-.254l1.255-6.162A.35.35,0,0,0,21.545,4",
    transform: "translate(0 0)",
    fill: "#0d3b66"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a9a21b24cc39dba6c5d3afdac439dce6.svg";
export { ForwardRef as ReactComponent };